import React from "react";
import { Flex, Grid, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { DomestikaLiveLogo } from "@domestika-dev/prudencio/dist/atoms/DomestikaLiveLogo";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography";
import { FormattedMessage } from "react-intl";

export const HeaderContent = () => (
  <Flex
    flexDirection="column"
    alignItems="center"
    marginTop={["34px", 8]}
    paddingLeft={[4, 5, "10px"]}
  >
    <Flex width={["100%", "100%", "944px", "1200px"]}>
      <Grid gridRowGap={5}>
        <GridItem gridColumn={1} gridRow={1}>
          <DomestikaLiveLogo width="224px" height="32px" />
        </GridItem>
        <GridItem gridColumn={1} gridRow={2}>
          <Text
            as="h1"
            size="gigantic"
            fontWeight="medium"
            maxWidth={["100%", "100%", "700px", "780px"]}
          >
            <FormattedMessage id="live_sessions.landing.title" />
          </Text>
        </GridItem>
        <GridItem gridColumn={1} gridRow={3}>
          <Text
            size="medium"
            fontWeight="medium"
            color="guijarro"
            maxWidth={["100%", "100%", "700px", "580px"]}
          >
            <FormattedMessage id="live_sessions.landing.subtitle" />
          </Text>
        </GridItem>
      </Grid>
    </Flex>
  </Flex>
);

export default HeaderContent;
